<template>
  <div class="bg-container page">
    <img class="bg-img" v-if="$store.getters.getBaseInfo.login_bg" :src="$store.getters.getBaseInfo.login_bg" />
    <!-- <img class="bg-img" src="@/assets/login-bg.png" /> -->
    <div class="bg-wrapper">
      <div class="login">
        <van-nav-bar class="nav-bar">
          <template #left v-if="this.$store.getters.getBaseInfo.video_login == 0">
            <van-icon name="arrow-left" color="#d7d7d7" @click="back()" />
          </template>
          <template #right>
            <div class="language" @click="$router.push('/language')">
              <img v-if="lang" :src="require('../images/language/' + lang + '.png')" />
            </div>
          </template>
        </van-nav-bar>
        <div class="wrapper">
          <div class="logo-container">
            <div class="logo-wrapper">
              <img
                class="logo-img"
                :src="
                  this.$store.getters.getBaseInfo.ico !== undefined
                    ? this.$store.getters.getBaseInfo.ico
                    : '/img/null.png'
                "
              />
            </div>
          </div>
          <!-- <div class="title">{{ this.$store.getters.getBaseInfo.name}}</div> -->
          <div class="loginForm">
            <van-field
              v-model="username"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.username_place')"
            />
            <van-field
              v-model="password"
              :type="passwordType"
              input-align="center"
              class="input"
              :placeholder="$t('auth.pwd_place')"
            >
              <template slot="right-icon">
                <van-icon
                color="#d1af6f"
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>
            <!-- <div class="reset-text" @click="noPsw">
              <span>{{$t("auth.forgetpwd")}}?</span>
            </div> -->
            <div @click="toRegister()" class="register-text" style="margin-top: 20px;">
              <span>{{$t("auth.no_account")}}</span>
            </div>
            <van-button
              class="login-btn"
                :class="{'active':username && password}"
              type="primary"
              size="normal"
              :disabled="isDisabled"
              @click="doLogin()"
              >{{$t("auth.login")}}</van-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      username: "",
      lang:'',
      password: this.inputValue,
      passwordType: "password",
      isDisabled:false
    };
  },
  mounted(){
    // localStorage.setItem("lang", 'ms_my');
    this.lang = localStorage.getItem("viodeLang") || this.$store.state.langDefault;
  },
  methods: {
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      this.$router.push('/')
      // return window.history.back();
    },
    noPsw() {

      // this.$toast(this.$t("auth.customerService"));
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined
      ) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }
      this.isDisabled = true
      this.$http({
        url: "member_login",
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          lang: this.lang
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("tokensso", res.data.tokensso);
          localStorage.setItem("token", res.data.id);
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
        this.isDisabled = false
      });
    },
  },
  created() {
    this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {
        if (res.code == 200) {

        if(!localStorage.getItem('token') && res.data.video_login == 1){
          this.$router.push({path:'/Login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
        }
      })
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.login {
  height: 100%;
}
.bg-container .bg-wrapper .login .nav-bar {
  background: 0 0;
}

.language{
		position: absolute;
		top: 4px;
		right: 0;
		height: 80px;
		img{
			height: 100%;
		}
	}

.login .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container {
  margin: 0 auto;
  width: 45%;
}
.logo-container .logo-wrapper {
  position: relative;
  padding-bottom: 62.5%;
}
.logo-container .logo-wrapper .logo-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
  opacity: 0.8;
}
.login .wrapper .title {
  line-height: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: 700;
  color: #d1af6f;
  letter-spacing: 5px;
}
.login .wrapper .loginForm {
  padding: 60px;
}
.login .wrapper .loginForm .input {
  padding: 10px 20px;
  margin-top: 40px;
  border-radius: 50px;
  text-align: center;
  line-height: 80px;
  font-size: 30px;
  color: #d1af6f;
  background-color: rgba(0, 0, 0, .5);
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}
::v-deep .van-icon {
  font-size: 50px;
}
.login .wrapper .loginForm .reset-text {
  margin: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.login .wrapper .loginForm .reset-text span {
  color: #d1af6f;
  font-size: 25px;
  font-weight: 500;
  line-height: 15px;
}
.login .wrapper .loginForm .register-text {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login .wrapper .loginForm .register-text span {
  color: #ffffff;
  font-size: 25px;
  font-weight: 500;
  line-height: 20px;
}
// .login .wrapper .loginForm .login-btn {
//   margin-top: 85px;
//   width: 100%;
//   height: 100px;
//   border-radius: 50px;
//   color: #d1af6f;
//   // background: linear-gradient(90deg, #d1af6f, #d1af6f);
//   font-size: 30px;
//   font-weight: bolder;
//   border: none;
// }

.login .wrapper .loginForm .login-btn {
  margin-top: 85px;
  width: 100%;
  height: 100px;
  background: linear-gradient(90deg, #d1af6f, #d1af6f);
    border-radius: 10px;
    color: #ffffff;
    font-size: 24px;
    font-weight: bolder;
    border: none;
    border-radius: 50px;
}
.login .wrapper .loginForm .active {
  color: #ffffff;
  background: linear-gradient(90deg, #d1af6f, #d1af6f);
}

::v-deep .login .wrapper .van-field__control, .login .wrapper .van-field__control{
  color: #fff !important;
  font-size: 24px;
}
</style>
